import { Check } from "lucide-react";
import { PRICING } from "./data";
import { Reveal, SectionHead } from "./shared";

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="border-y border-slate-800 bg-[#0C111C]">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <SectionHead
          index="04"
          overline="Pricing"
          title="Published pricing, pilot-first"
          note="Founding offer: the first data-center pilots run at $1,000 flat. List pricing below applies after."
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {PRICING.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08} className="h-full">
              <div
                data-testid={t.testid}
                className={`relative flex h-full flex-col rounded-lg border p-7 transition-transform duration-300 hover:-translate-y-1 ${
                  t.popular
                    ? "border-[#FF5500] bg-[#111827] shadow-[0_0_40px_rgba(255,85,0,0.12)]"
                    : "border-slate-800 bg-[#0D1320]"
                }`}
              >
                {t.popular && (
                  <span className="absolute -top-3 left-6 rounded-full bg-[#FF5500] px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-widest text-white">
                    Best fit for data centers
                  </span>
                )}
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">{t.name}</p>
                <div className="mt-4 flex items-baseline gap-1">
                  <span className="font-display text-4xl font-semibold text-slate-100">{t.monthly}</span>
                  <span className="font-mono text-sm text-slate-500">{t.period}</span>
                </div>
                <p className="mt-1 font-mono text-xs uppercase tracking-widest text-[#FF7A33]">{t.install}</p>
                <p className="mt-3 text-sm text-slate-500">{t.target}</p>
                <ul className="mt-6 flex-1 space-y-3 border-t border-slate-800 pt-6">
                  {t.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-slate-300">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#FF5500]" strokeWidth={2.5} />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p data-testid="pricing-honesty-note" className="mt-8 max-w-2xl text-sm leading-relaxed text-slate-500">
            No customer is paying these rates yet — that is the honest part. The $1,000 founding
            pilot exists to earn the first ones.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
